module.exports = __webpack_public_path__ + "static/en-28a783f2adf840732b1ad5ed3e5a9e2d.jpg";